import { setValueValue } from '@databases/collab/y-database';
import { DatabaseChangeType } from '@databases/types/redux';

import { dbFieldTypeMap, valueToCollabJSON } from '../../../collab/convert-to-collab';
import { YJSChangeHandler } from '../../types';

export const addEntry: YJSChangeHandler<DatabaseChangeType.ADD_ENTRY> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    const entry =
      change.index != null
        ? db.addEntryAt(change.entry.id, change.index)
        : db.addEntry(change.entry.id);

    for (const fieldId of Object.keys(change.entry.values)) {
      const type = dbFieldTypeMap[change.entry.values[fieldId].type];

      if (!type) {
        throw new Error('unsupported field type ' + change.entry.values[fieldId].type);
      }

      const value = entry.setValue(fieldId, type);
      const collabValue = valueToCollabJSON(change.entry.values[fieldId], {});

      if (collabValue) {
        setValueValue(value, collabValue);
      }
    }
  });
};
